export default __webpack_public_path__ + "static/media/img04.564644ef.jpg";